module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-500-normal.woff2?f25d774ecfe0996f8eb574b643d41915";